/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonHris/*, HrisCard,*/, Time, TimeIcon, Wrapper, BackgroundCard, HrisCardDisconnect, DownAngle} from './style';
import { ImageUrl } from '../../utils/constants';
import { getLastSyncDetails } from "../../utils/methods";
import DropdownButton from 'react-bootstrap/DropdownButton';
import { Dropdown } from "react-bootstrap";
import {/*AddTeamIcon, DeleteIcon,*/ MenuVertical} from '../../utils/icons'

class HrisCardComponent extends Component {
  constructor() {
    super();
    this.state = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      isExpired: false,
    };
  }

  componentDidMount() {
    const {data}= this.props;
    this.interval = setInterval(() => this.updateCountdown(data.next_sync_date), 1000);
    this.updateCountdown(data.next_sync_date);
  }

  componentDidUpdate(prevProps) {
    const {data}= this.props;
    if(prevProps.data.next_sync_date !== this.props.data.next_sync_date) {
      this.updateCountdown(data.next_sync_date);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  updateCountdown(date) {
    const targetDate = new Date(date);
    const now = new Date();
    const timeDifference = targetDate - now;

    if (timeDifference < 0) {
      this.setState({ isExpired: true });
      clearInterval(this.interval);
      return;
    }

    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    this.setState({
      days,
      hours,
      minutes,
      seconds,
    });
  }

  render() {
    const {  data, showSyncPopup, showHideDeleteConsumer, getApiDeck } = this.props
    const {days, hours, minutes} = this.state
    return (
      <BackgroundCard>
        <HrisCardDisconnect margin="0px" padding="16px">
          <div className='wrap'>
            <div className='image'>
              <img src={data.icon}/>
            </div>
            <div className='details'>
              <div className='menu'>
                <DownAngle  feed style={{display:"flex", margin:"auto 0 auto auto"}} height="95px" backgroundV>
                  <DropdownButton id="editDelete" title={MenuVertical()}>
                    <Dropdown.Item onClick={()=>getApiDeck()} >
                      {("Edit")}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={()=>showHideDeleteConsumer()} >
                      {("Delete")}
                    </Dropdown.Item>
                  </DropdownButton>
                </DownAngle>
              </div>
              {data?.state==="callable"?<>
                <div className='subText'>HRIS sync: {getLastSyncDetails(data?.last_sync_date)}</div>
                <div className='nextcount'>Next sync countdown</div>
                <Wrapper>
                  <Time>
                    <div className='timeMain'>
                      <div className='timeCard'>{days?days:"00"}</div>
                      <div className='days'>Days</div>
                    </div>
                    <TimeIcon>
                      <img src={ImageUrl+"/Hris-image/time.svg"}/>
                    </TimeIcon>
                    <div className='timeMain'>
                      <div className='timeCard'>{hours?hours:"00"}</div>
                      <div className='days'>Hours</div>
                    </div>
                    <TimeIcon>
                      <img src={ImageUrl+"/Hris-image/time.svg"}/>
                    </TimeIcon>
                    <div className='timeMain'>
                      <div className='timeCard'>{minutes?minutes:"00"}</div>
                      <div className='days'>Min</div>
                    </div>
                  </Time>
                </Wrapper>
              </>:
                <>
                  <div className='name'>{data?.name}</div>
                  <div className='incomplete'>Unauthorized</div>
                  <div className='subText'>Click the {`"${"Authorize"}"`} button to<br/> authorize HRIS Software.</div>
                </>}
            </div>
          </div>
          {data?.state==="callable"?<ButtonHris margin="8px" width="100%" disable={data?.next_sync_date && minutes} onClick={ data?.next_sync_date && minutes? null: ()=>showSyncPopup()}>
            {data.next_sync_date?"Edit Sync":"Schedule Sync"}
          </ButtonHris>:
            <ButtonHris onClick={()=>getApiDeck()} margin="8px" width="100%">
              {"Authorize"}
            </ButtonHris>}
        </HrisCardDisconnect>
      </BackgroundCard>
      // <HrisCard >
      //   <div className='wrapper'>
      //     <div className='image'>
      //       <img src={data.icon}/>
      //     </div>
      //     <div className='details'>
      //       <div className='lastsync'>Last sync: {getLastSyncDetails(data?.last_sync_date)}</div>
      //       <div className='nextsync'>Next sync countdown</div>
      //       <Wrapper>
      //         <Time>
      //           <div className='timeMain'>
      //             <div className='timeCard'>{days?days:"00"}</div>
      //             <div className='days'>Days</div>
      //           </div>
      //           <TimeIcon>
      //             <img src={ImageUrl+"/Hris-image/time.svg"}/>
      //           </TimeIcon>
      //           <div className='timeMain'>
      //             <div className='timeCard'>{hours?hours:"00"}</div>
      //             <div className='days'>Hours</div>
      //           </div>
      //           <TimeIcon>
      //             <img src={ImageUrl+"/Hris-image/time.svg"}/>
      //           </TimeIcon>
      //           <div className='timeMain'>
      //             <div className='timeCard'>{minutes?minutes:"00"}</div>
      //             <div className='days'>Min</div>
      //           </div>
      //           <TimeIcon>
      //             <img src={ImageUrl+"/Hris-image/time.svg"}/>
      //           </TimeIcon>
      //           <div className='timeMain'>
      //             <div className='timeCard'>{seconds?seconds:"00"}</div>
      //             <div className='days'>Sec</div>
      //           </div>
      //         </Time>
      //       </Wrapper>
      //     </div>
      //   </div>
      //   <ButtonHris disable={data.next_sync_date && minutes} onClick={ data.next_sync_date && minutes? null: ()=>showSyncPopup()}>
      //     {data.next_sync_date?"Edit Sync":"Schedule Sync"}
      //   </ButtonHris>
      // </HrisCard>
    )
  }
}

HrisCardComponent.propTypes = {
  showSyncPopup: PropTypes.func,
  data: PropTypes.array,
  showHideDeleteConsumer: PropTypes.func,
  getApiDeck: PropTypes.func
};

export default connect(null, null)(HrisCardComponent);
